import { render, staticRenderFns } from "./FeTabsComponent.vue?vue&type=template&id=f060478c&scoped=true&"
import script from "./FeTabsComponent.vue?vue&type=script&lang=js&"
export * from "./FeTabsComponent.vue?vue&type=script&lang=js&"
import style0 from "./FeTabsComponent.vue?vue&type=style&index=0&id=f060478c&lang=scss&scoped=true&"
import style1 from "./FeTabsComponent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f060478c",
  null
  
)

export default component.exports